import api from '@utils/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import acccountSlice from './account.slice';
import { AccountActionTypes } from './common.types';
function* handleFetchAddresses() {
    const callresult = yield call(api.getAddressBook);
    const addresses = callresult.addresses;
    yield put(acccountSlice.actions.updateAddresses(addresses));
}
function* handleFetchProfile() {
    const profile = yield call(api.getProfile);
    yield put(acccountSlice.actions.updateProfile(profile));
}
function* handleFetchAccountModel() {
    const accountModel = yield call(api.getAccountModel);
    yield put(acccountSlice.actions.updateModel(accountModel));
}
function* handleDeleteAddresses(action) {
    yield call(api.deleteAddress, action.payload.id, action.payload.isDefault);
    yield handleFetchAddresses();
}
function* handleFetchPaymentInstruments() {
    const paymentInstrumentResponse = yield call(api.getCustomerPaymentInstruments);
    yield put(acccountSlice.actions.updatePaymentInstruments(paymentInstrumentResponse.paymentInstruments));
    yield put(acccountSlice.actions.updateAdyenConfig(paymentInstrumentResponse.adyenConfig));
}
function* handleDeleteSavedCard(action) {
    const paymentInstrumentResponse = yield call(api.deletePaymentMethod, action.payload.id);
    yield put(acccountSlice.actions.updatePaymentInstruments(paymentInstrumentResponse.paymentInstruments));
}
function* watchFetchRequest() {
    yield takeEvery(AccountActionTypes.FETCH_ADDRESSES, handleFetchAddresses);
    yield takeEvery(AccountActionTypes.FETCH_PROFILE, handleFetchProfile);
    yield takeEvery(AccountActionTypes.FETCH_MODEL, handleFetchAccountModel);
    yield takeEvery(AccountActionTypes.DELETE_ADDRESSES, handleDeleteAddresses);
    yield takeEvery(AccountActionTypes.FETCH_SAVEDCARDS, handleFetchPaymentInstruments);
    yield takeEvery(AccountActionTypes.DELETE_SAVEDCARD, handleDeleteSavedCard);
}
export default function* accountSaga() {
    yield all([fork(watchFetchRequest)]);
}
